import { render } from "./UserImport.vue?vue&type=template&id=25f5bee7&ts=true"
import script from "./UserImport.vue?vue&type=script&lang=ts"
export * from "./UserImport.vue?vue&type=script&lang=ts"

import "./UserImport.vue?vue&type=style&index=0&id=25f5bee7&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__